<h2 mat-dialog-title>
  {{ isNew ? 'Add Beneficiary' : 'Edit Beneficiary' }}
</h2>

<mat-dialog-content class="panel-body">

  <div class="form-row">
    <label>Name</label>
    <input type="text" [(ngModel)]="beneficiary.name" />
  </div>

  <div class="form-row">
    <label>Address Line 1</label>
    <input type="text" [(ngModel)]="beneficiary.addressLine1" />
  </div>

  <div class="form-row">
    <label>Beneficiary URN</label>
    <input type="text" [(ngModel)]="beneficiary.beneficiarySourceURN" />
  </div>

  <div class="form-row">
    <label>Address Line 2</label>
    <input type="text" [(ngModel)]="beneficiary.addressLine2" />
  </div>


  <div class="form-row">
    <label>Source</label>
    <input type="text" [(ngModel)]="beneficiary.source.name" readonly />
  </div>

  <div class="form-row">
    <label>Address Line 3</label>
    <input type="text" [(ngModel)]="beneficiary.addressLine3" />
  </div>

  <!-- ALIASES -->
  <div class="form-row">
    <label>Aliases</label>

    <div class="chip-list" *ngIf="beneficiary.aliasArray.length">
      <span class="alias-chip" *ngFor="let a of beneficiary.aliasArray; let i = index">
        {{ a }}
        <button type="button" class="chip-remove" (click)="removeAlias(i)">×</button>
      </span>
    </div>

    <div class="alias-add-row">
      <input type="text"
             placeholder="Add alias"
             [(ngModel)]="beneficiary.newAlias"
             (keyup.enter)="addAlias()" />
      <button class="add-btn" (click)="addAlias()">+</button>
    </div>
  </div>

  <div class="form-row">
    <label>Address Line 4</label>
    <input type="text" [(ngModel)]="beneficiary.addressLine4" />
  </div>

  <div class="form-row">
    <label>Previous Names</label>
    <input type="text" [(ngModel)]="beneficiary.previousNames" />
  </div>


  <div class="form-row">
    <label>Postcode</label>
    <input type="text" [(ngModel)]="beneficiary.postcode" />
  </div>


  <div class="form-row">
    <label>Activities</label>
    <div class="activities-input-box">
      <span class="alias-chip category-chip" *ngIf="selectedCategories.length">
        {{ selectedCategories.length }} {{ selectedCategories.length === 1 ? 'activity' : 'activities' }} selected
        <button type="button" class="chip-remove" (click)="clearAllCategories()">×</button>
      </span>
      <input type="text" [(ngModel)]="beneficiary.activities" placeholder="" />
      <button type="button" class="dots-btn" (click)="openCategoryPopup()" title="Select activity categories">⋯</button>
    </div>
  </div>

  <div class="form-row">
    <label>Web</label>
    <input type="text" [(ngModel)]="beneficiary.web" />
  </div>

  <div class="form-row" style="display:flex; flex-direction:row; gap:16px; align-self:center;justify-self:flex-start">
    <label>
      <input type="checkbox" [(ngModel)]="beneficiary.active" />
      Active
    </label>
  </div>

  <div class="form-row">
    <label>Telephone</label>
    <input type="text" [(ngModel)]="beneficiary.telephone" />
  </div>



</mat-dialog-content>

<mat-dialog-actions align="end" class="panel-actions" style="display:flex;gap:10px">
  <button class="btn cancel" (click)="cancel()">Cancel</button>
  <button class="btn save" (click)="save()">Save</button>
</mat-dialog-actions>

<!-- Activity Category Popup -->
<div class="bcat-popup-overlay" *ngIf="isCategoryPopupOpen">
  <div class="bcat-popup-dialog">
    <div class="bcat-popup-header">
      <h3>Select Activity Categories</h3>
      <button class="bcat-close-btn" (click)="closeCategoryPopup()" title="Close">✕</button>
    </div>
    <div class="bcat-popup-content">
      <div class="bcat-search-box">
        <input type="text" placeholder="Search activities..."
               [(ngModel)]="categorySearchTerm"
               (ngModelChange)="filterCategories()"
               class="bcat-search-input" />
      </div>
      <div class="bcat-list">
        <div *ngIf="filteredCategoriesList.length === 0" class="bcat-empty">No activities found</div>
        <label *ngFor="let cat of filteredCategoriesList" class="bcat-item">
          <input type="checkbox"
                 [checked]="isCategorySelected(cat)"
                 (change)="toggleCategory(cat)" />
          <span>{{ cat.parent }} - {{ cat.child }}</span>
        </label>
      </div>
    </div>
    <div class="bcat-selected-summary" *ngIf="selectedCategories.length > 0">
      <span class="bcat-selected-label">Selected ({{ selectedCategories.length }}):</span>
      <div class="bcat-chips">
        <span *ngFor="let item of selectedCategories" class="alias-chip bcat-chip-green">
          {{ item.category }} - {{ item.activity }}
          <button type="button" class="chip-remove" (click)="removeCategoryChip(item)">×</button>
        </span>
      </div>
    </div>
    <div class="bcat-popup-footer">
      <button class="btn cancel" (click)="closeCategoryPopup()">Cancel</button>
      <button class="btn save" (click)="applyCategories()">Done</button>
    </div>
  </div>
</div>
